"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobxReactLite = require("mobx-react-lite");
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _api = require("../../services/api");
var _theme = require("../../theme");
var _reactNativeUiLib = require("react-native-ui-lib");
var _DynamicForm = _interopRequireWildcard(require("../DynamicForm"));
var _DynamicTable = _interopRequireDefault(require("../DynamicTable"));
var _reactRouterDom = require("react-router-dom");
var _state = require("../state");
var _native = require("@react-navigation/native");
var _LayoutScreen = _interopRequireDefault(require("./LayoutScreen"));
var _FormScreen = _interopRequireDefault(require("./FormScreen"));
var _ListingScreen = _interopRequireDefault(require("./ListingScreen"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // 
var EditScreen = (0, _mobxReactLite.observer)(function EditScreen(props) {
  var _route, _route2, _props$route;
  var _useStores = (0, _state.useStores)(),
    _useStores$formStore = _useStores.formStore,
    getOpenModals = _useStores$formStore.getOpenModals,
    setOpenModal = _useStores$formStore.setOpenModal,
    getModalHistory = _useStores$formStore.getModalHistory,
    deleteModel = _useStores$formStore.deleteModel;
  var route = props.route;
  var params = (_route = route) !== null && _route !== void 0 && _route.params ? (_route2 = route) === null || _route2 === void 0 ? void 0 : _route2.params : (0, _reactRouterDom.useParams)();
  var nativeRoute = (0, _native.useNavigationState)(function (state) {
    return state;
  });
  var navigation = (0, _native.useNavigation)();
  var navigate = null;
  var queryParams = _objectSpread({}, (props === null || props === void 0 || (_props$route = props.route) === null || _props$route === void 0 ? void 0 : _props$route.params) || {});
  if (_reactNative.Platform.OS === 'web') {
    var _window;
    navigate = (0, _reactRouterDom.useNavigate)();
    var path = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname;
    route = {
      name: path.split("/")[1] || 'Items'
    };
    var _params = window.location.search.substring(1).split('&');
    _params.map(function (param) {
      var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];
      if (key) {
        queryParams[key] = value;
      }
    });
  }
  var navigationFn = function navigationFn(path, params) {
    if (_reactNative.Platform.OS === 'web') {
      var paramsString = "";
      if (params) {
        paramsString = "?" + Object.keys(params).map(function (key) {
          return key + '=' + params[key];
        }).join('&');
      }
      navigate("/" + path + paramsString);
    } else {
      if (path.includes("report/")) {
        navigation.navigate("report", _objectSpread(_objectSpread({}, params), {}, {
          name: path.replace("report/", "")
        }));
      } else {
        navigation.navigate(path, params);
      }
    }
  };
  (0, _react.useEffect)(function () {
    // navigationFn(route.name + '/New/', {
    //     moduleName: route.name,
    //     isVisible: true,
    //     moduleName: route.name,
    //     afterSaveEvent: 'reloadListing',
    //     ...(props.default_values ? props.default_values : {})
    //   })

    setOpenModal(_defineProperty({}, route.name, _objectSpread({}, queryParams)));
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_ListingScreen["default"], props);
});
var _default = exports["default"] = EditScreen;
var $container = {
  flex: 1
};